import { apiFetch } from '@/apiFetch';

export function responseFilename(response: Response, fallback: string): string {
  const disposition = response.headers.get('Content-Disposition') ?? '';
  const encoded = /filename\*=UTF-8''([^;]+)/i.exec(disposition)?.[1];
  let filename: string | undefined;
  try {
    filename = encoded ? decodeURIComponent(encoded) : undefined;
  } catch {
    /* use plain filename */
  }
  filename ??=
    /filename="([^"]+)"/i.exec(disposition)?.[1] ??
    /filename=([^;]+)/i.exec(disposition)?.[1];
  return (filename?.trim() || fallback).replace(/[\\/]/g, '_');
}

/** A private download needs the same per-tab context as every API request. */
export async function downloadApiFile(
  path: string,
  fallback: string,
): Promise<void> {
  const response = await apiFetch(path, { cache: 'no-store' });
  if (!response.ok)
    throw new Error(`Download unavailable (${response.status})`);
  const url = URL.createObjectURL(await response.blob());
  const link = document.createElement('a');
  link.href = url;
  link.download = responseFilename(response, fallback);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}
